import React, { useEffect, useState, useCallback } from "react";
import { Link, Links } from "react-router-dom";
import Modal from "react-bootstrap/Modal";
import Api from "../Api/Api";

function Page({ datauser }) {
  const [userprofile, setUserprofile] = useState(false);
  const [userbalance, setUserbalance] = useState();
  // const [userName, setUserName] = useState();
  const [show, setShow] = useState(false);
  // const [loading, setLoading] = useState(false);
  const Auth = localStorage.getItem("Quizetoken");

  const [auth, setAuth] = useState(null);
  const [userProfile, setUserProfile] = useState(false);
  const [userName, setUserName] = useState("");
  const [wallet, setWallet] = useState("");
  const [loading, setLoading] = useState(false);

  const clientid = localStorage.getItem("UserIdclient");
  const user = localStorage.getItem("userName");
  // const wallet = localStorage.getItem("wallet");

  // const user = "";
  // const wallet = "";
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const Getbalance = useCallback(async () => {
    const formData = new FormData();
    formData.append("userid", 1);
    try {
      const response = await Api.get(
        `/user/userWalletBalance?userid=${clientid}`
      );
      // console.log("Dattataat---->", response.data.result);
      localStorage.setItem("wallet", response.data.result);
      setUserbalance(response.data.result);
    } catch (error) {
      console.log(error);
    }
  }, []);

  const getProfile = async () => {
    const token = localStorage.getItem("Quizetoken");
    if (!token) return; // Don't call API if user is not logged in

    try {
      setLoading(true);
      const res = await Api.get("user/get-profile");
      // console.log("Profile", res.data.result);
      setUserName(res.data.result?.userName);
    } catch (error) {
      console.log("Error", error);
    }
    // }
    setLoading(false);
  };

  const modelDisplay = () => {
    handleShow();
  };

  const logoutFun = () => {
    // localStorage.removeItem("Quizetoken")
    // localStorage.removeItem("UserIdclient")
    // localStorage.removeItem("UserIdMongo")
    localStorage.clear();
    handleClose();
    window.location.reload();

    window.dispatchEvent(new Event("storage"));
    setUserProfile(false);

    // navigator('/')
  };

  // console.log("Datauser", datauser);
  // useEffect(() => {
  //   Getbalance();
  // }, [datauser]);

  // useEffect(() => {
  //   if (Auth) {
  //     setUserprofile(true);
  //     Getbalance();
  //     // getProfile();
  //   } else {
  //     setUserprofile(false);
  //   }
  // }, [Auth]);

  useEffect(() => {
    const token = localStorage.getItem("Quizetoken");
    const storedUser = localStorage.getItem("userName");
    const storedWallet = localStorage.getItem("wallet");

    setAuth(token);
    setUserName(storedUser);
    setWallet(storedWallet);

    if (token) {
      setUserProfile(true);
      Getbalance();
    } else {
      setUserProfile(false);
    }
  }, []);

  useEffect(() => {
    const handleStorageChange = () => {
      const token = localStorage.getItem("Quizetoken");
      const storedUser = localStorage.getItem("userName");
      const storedWallet = localStorage.getItem("wallet");

      setAuth(token);
      setUserName(storedUser);
      setWallet(storedWallet);

      if (token) {
        setUserProfile(true);
      } else {
        setUserProfile(false);
      }
    };

    window.addEventListener("storage", handleStorageChange);
    return () => window.removeEventListener("storage", handleStorageChange);
  }, []);

  // Optional: Poll localStorage every 3s to keep wallet in sync
  useEffect(() => {
    const interval = setInterval(() => {
      const storedWallet = localStorage.getItem("wallet");
      setWallet(storedWallet);
    }, 3000);

    return () => clearInterval(interval);
  }, []);

  return (
    <>
      <div className="menu-wrap">
        {userprofile ? (
          <>
            <div className="cmn-head" style={{ marginLeft: "-64px" }}>
              <Link
                to="/transaction-history"
                className="instructions"
                style={{ marginTop: "13px" }}
              >
                <div className="part-icon ">
                  <img src="/assets/images/image77.png" alt="" />
                  <span>{userbalance}</span>
                </div>
              </Link>
            </div>
          </>
        ) : (
          ""
        )}
        <input type="checkbox" className="toggler" />

        <div className="hamburger">
          <div></div>
        </div>
        <div className="menu">
          <div>
            <div>
              <ul>
                <li>
                  <Link to="/">Home</Link>
                </li>
                {userprofile ? (
                  <>
                    <li>
                      <Link to="/free-game-leaderboard">leaderboard</Link>
                      {/* <div className="sub-menu-list"></div> */}
                    </li>

                    <li>
                      <Link to="/transaction-history">Transaction History</Link>
                    </li>
                    <li>
                      <Link to="/wallet">Connect Wallet</Link>
                    </li>

                    <li>
                      <Link to="/profile">Profile</Link>
                    </li>

                    <li>
                      <Link to="/referral-link">Referral Link</Link>
                    </li>

                    <li>
                      <a onClick={() => modelDisplay()}>Log Out</a>
                    </li>
                  </>
                ) : (
                  <>
                    <li
                      href="transaction-history.html"
                      className="instructions"
                    >
                      <div className="part-icon header">
                        {/* <img src="/assets/images/image77.png" alt="" />
                    <span>100</span> */}
                      </div>
                    </li>
                    <li>
                      <Link to="/instruction">Instruction</Link>
                    </li>
                    <li>
                      <Link to="/login">Login</Link>
                    </li>
                    {/* <!-- <li><a href="signup.html">Signup</a></li> --> */}
                  </>
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>

      {/* <header className="header-section header-menu">
          <nav className="navbar w-100  ">
            <div className="container flex-nowrap     navbar-expand-xl">
              <Link to='/' className="navbar-brand   ">
                <img
                  src="/assets/images/logo-text.png"
                  className="logo-text d-xxl-block "
                  alt="logo-text"
                />
              </Link>
              <div
                className="collapse navbar-collapse d-flex gap-10 w-100 justify-content-end px-8 pe-2"
                id="navbar-content"
              >
                <div className="right-area position-relative d-flex gap-3 gap-xxl-6 align-items-center">
                  <div className="single-item nav-flex">
                    {userprofile ? (
                      <>
                    <Link to="/transaction-history" class="instructions">
                    <div class="part-icon header">
                                <img src="/assets/images/image77.png" alt="" />
								                <span>{userbalance}</span>
                    </div>
                    </Link>
                      </>): ''  }
                    <Link to='/instruction' className="instructions">
                      Instructions
                    </Link>
                     {userprofile ? (
                       <>
                      <Link to='/profile'  className="profile-icon"><i className="fa-regular fa-user"></i></Link>  
                      {/* <h5  onClick={() => modelDisplay()} style={{color:"white",cursor:"pointer"}}>Logout</h5>   
                       </>
                     ):(
                      <>
                    <div className="cmn-head">
                      <Link
                        // href="Login-1.html"
                        to="/login"
                        type="button"
                        className="icon-area d-center position-relative box-style btn-box d-center"
                      >
                        Log In
                      </Link>
                     


                    </div>
                    </>
                     )}
                    


                    <Modal show={show} onHide={handleClose} centered size="lg"  aria-labelledby="example-modal-sizes-title-lg">
                    {/* <Modal.Body></Modal.Body> 
                    <div className="Coupon-details pd-0">
                      <div className="about-logout profile-logout">
                        <img
                          src="/assets/images/logout.png"
                          className="log-out"
                        />
                        <h4>
                          Are you sure, <span>you want to logout?</span>
                        </h4>
                        <div className="logout-btn">
                          <a onClick={()=>setShow(false)}>Cancel</a>
                          <a  onClick={()=>logoutFun()}className='logout'>Logout</a>
                        </div>
                      </div>
                    </div>
                  </Modal>

                  </div>
                </div>
              </div>
            </div>
          </nav>
        </header> */}

      {/* <header className="header-section header-menu">
        <nav className="navbar w-100">
          <div className="container flex-nowrap     navbar-expand-xl">
            <Link to="/" className="navbar-brand   ">
              <img
                src="/assets/images/logo-text.png"
                className="logo-text d-xxl-block "
                alt="logo-text"
              />
            </Link>
            <div
              className="collapse navbar-collapse d-flex gap-10 w-100 justify-content-end px-8 pe-2"
              id="navbar-content"
            >
              <div className="right-area position-relative d-flex gap-3 gap-xxl-6 align-items-center">
                {loading ? (
                  ""
                ) : (
                  <div className="single-item nav-flex">
                    <Link to="/" className="instructions">
                      Home
                    </Link>

                    {userprofile ? (
                      <>
                        <div className="cmn-head">
                          <Link to="/profile" className="instructions">
                            <div className="part-icon ">
                              <img
                                src="/assets/images/userLogo.jpeg"
                                alt=""
                                style={{
                                  height: "40px",
                                  width: "47px",
                                  borderRadius: "48%",
                                }}
                              />
                              <span>{user}</span>
                            </div>
                          </Link>
                        </div>
                        <div className="cmn-head">
                          <Link
                            to="/transaction-history"
                            className="instructions"
                          >
                            <div className="part-icon ">
                              <img src="/assets/images/image77.png" alt="" />
                              <span>{wallet}</span>
                            </div>
                          </Link>
                        </div>
                      </>
                    ) : (
                      ""
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </nav>
      </header> */}
      <header
        className="header-section header-menu"
        // style={{ border: "2px solid green", height: "80px" }}
      >
        <nav
          className="navbar w-100"
          style={{ height: "80px" }}
        >
          <div className="container flex-nowrap navbar-expand-xl" style={{height:"70px", paddingBottom:"10px"}}>
            <Link to="/" className="navbar-brand">
              <img
                src="/assets/images/logo-text.png"
                className="logo-text d-xxl-block"
                alt="logo-text"
                // style={{ border: "2px solid red" }}
              />
            </Link>
            <div
              className="collapse navbar-collapse d-flex gap-10 w-100 justify-content-end px-8 pe-2"
              id="navbar-content"
            >
              <div className="right-area position-relative d-flex gap-3 gap-xxl-6 align-items-center">
                {!loading && (
                  <div className="single-item nav-flex">
                    <Link to="/" className="instructions">
                      Home
                    </Link>

                    {userProfile && (
                      <>
                        <div className="cmn-head">
                          <Link to="/profile" className="instructions">
                            <div className="part-icon">
                              <img
                                src="/assets/images/userLogo.jpeg"
                                alt=""
                                style={{
                                  height: "40px",
                                  width: "47px",
                                  borderRadius: "48%",
                                }}
                              />
                              <span>{userName}</span>
                            </div>
                          </Link>
                        </div>
                        <div className="cmn-head">
                          <Link
                            to="/transaction-history"
                            className="instructions"
                          >
                            <div className="part-icon">
                              <img src="/assets/images/image77.png" alt="" />
                              <span>{wallet}</span>
                            </div>
                          </Link>
                        </div>
                      </>
                    )}
                  </div>
                )}
              </div>
            </div>
          </div>
        </nav>
      </header>
      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        aria-labelledby="example-modal-sizes-title-lg"
      >
        {/* <Modal.Body></Modal.Body> */}
        <div className="Coupon-details pd-0">
          <div className="about-logout profile-logout">
            <img src="/assets/images/logout.png" className="log-out" />
            <h4>
              Are you sure, <span>you want to logout?</span>
            </h4>
            <div className="logout-btn">
              <a onClick={() => setShow(false)}>Cancel</a>
              <a onClick={() => logoutFun()} className="logout">
                Logout
              </a>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
}

export default Page;
